const toCamelCase = (value: string): string =>
  value.replace(/[-_]+(.)/g, (_, character) => character.toUpperCase());

const isDynamicPathSegment = (segment: string): boolean =>
  /^\d+$/.test(segment) ||
  /^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(segment) ||
  segment.length > 48 ||
  // Any segment carrying a digit is treated as a URL param/id/version token
  // (e.g. an order id, "v2") rather than a meaningful API name segment.
  /\d/.test(segment);

const getPathSegments = (requestUrl: string): string[] => {
  const { pathname } = new URL(requestUrl, 'https://tracking.invalid');
  return pathname.split('/').filter(Boolean);
};

export const getCanonicalApiName = (requestUrl: string): string => {
  try {
    const segments = getPathSegments(requestUrl);

    for (let index = segments.length - 1; index >= 0; index -= 1) {
      const segment = segments[index];
      if (!isDynamicPathSegment(segment)) return toCamelCase(segment);
    }
  } catch {
    // A malformed or unavailable URL is reported without exposing raw data.
  }

  return 'unknownApi';
};

const API_SOURCE_PREFIXES: Array<[string, string]> = [
  ['mcssapi', 'mcss'],
  ['mcss', 'mcss'],
  ['onepass', 'mcss'],
  ['online-eshop', 'eshop'],
  ['eshop', 'eshop'],
  ['idpf-auth', 'eshop'],
  ['oauth', 'eshop'],
  ['catalog', 'eshop'],
  ['bin', 'aem'],
  ['aem', 'aem']
];

export const getApiSource = (requestUrl: string): string => {
  try {
    const segments = getPathSegments(requestUrl);
    const apiVersionIndex = segments.findIndex(
      (segment, index) =>
        segment === 'api' &&
        segments[index + 1] === 'sg' &&
        /^v\d+$/i.test(segments[index + 2] || '')
    );
    const sourceSegment =
      apiVersionIndex >= 0 ? segments[apiVersionIndex + 3] : segments[0];

    if (sourceSegment) {
      const matched = API_SOURCE_PREFIXES.find(
        ([prefix]) =>
          sourceSegment === prefix || sourceSegment.startsWith(prefix)
      );
      if (matched) return matched[1];
    }
  } catch {
    // An unknown URL is grouped without exposing the raw URL.
  }

  return 'unknown';
};
